export const expenseData = [
  {
    id: 1,
    name: "Mortgage Interest",
    description:
      "Interest portion of mortgage payments and interest on loans used to acquire or improve the property.",
  },
  {
    id: 2,
    name: "Other Interest",
    description:
      "Interest on business credit cards or unsecured loans used specifically for rental property expenses.",
  },
  {
    id: 3,
    name: "Property Taxes",
    description:
      "State and local real estate taxes levied on the rental property.",
  },
  {
    id: 4,
    name: "Cleaning",
    description:
      "Cost to clean the property, such as maid service, carpet cleaning, cleaning associated with move-out, etc",
  },
  {
    id: 5,
    name: "Repairs and Maintenance",
    description:
      "Costs to maintain the property's current operating condition, such as plumbing repairs, minor painting, or fixing a broken appliance.",
  },
  {
    id: 6,
    name: "Insurance Premiums",
    description:
      "Payments for landlord, hazard, fire, flood, and general liability insurance policies.",
  },
  {
    id: 7,
    name: "Property Management",
    description:
      "Fees paid to a professional third-party company for managing the property.",
  },
  {
    id: 8,
    name: "Legal and Professional",
    description:
      "Expenses for attorneys (evictions, lease drafting), CPAs, tax preparation, and bookkeeping services.",
  },
  {
    id: 9,
    name: "Advertising and Marketing",
    description:
      "Costs for promoting vacancies, including online listing fees, signage, and print materials.",
  },
  {
    id: 10,
    name: "Utilities",
    description:
      "Costs for services like gas, electric, water, sewer, or trash collection when paid by the landlord, especially during vacancies or for common areas (Only those fees paid by landlord).",
  },
  {
    id: 11,
    name: "HOA or Condo Fees",
    description:
      "Mandatory fees paid to a Homeowners Association or condo management.",
  },
  {
    id: 12,
    name: "Travel",
    description:
      "Costs for business-related trips to the property, deductible via the standard mileage rate or actual vehicle expenses.",
  },
  {
    id: 13,
    name: "Tenant Acquisition",
    description:
      "Fees paid to a broker or real estate agent for securing new tenants.",
  },
  {
    id: 14,
    name: "Software and Supplies",
    description:
      "Costs for dedicated rental software or subscriptions (Snappily), and general office expenses, small tools, postage, etc. ",
  },
  {
    id: 15,
    name: "Landscaping and Grounds",
    description:
      "Expenses for lawn care, snow removal, gardening, and overall upkeep of the grounds.",
  },
  {
    id: 16,
    name: "Trash Removal",
    description:
      "Expenses related to trash removal, dump fees, and/or recycling.",
  },
  {
    id: 17,
    name: "Pest Control",
    description:
      "Fees paid to contractors for ongoing or emergency pest and termite management.",
  },
  {
    id: 18,
    name: "Tenant Screening",
    description:
      "Costs associated with running background checks, credit reports, and eviction history on prospective tenants.",
  },
  {
    id: 19,
    name: "Licenses and Permits",
    description:
      "Fees required by local and state governments for operating the property as a rental unit.",
  },
  {
    id: 20,
    name: "Other Expense",
    description: "Any expense that doesn't meet any of other category above.",
  },
];
